import {
  TableActionBarButton,
  TableActionBarRoot,
  TableActionBarRowsSelected,
} from "@/components/shared/data-table/action-bar";
import type { Table } from "@tanstack/react-table";
import { Check, Trash2, X } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InvoicesTab } from "./invoices-data-table";

type Props = {
  table: Table<any>;
  onDelete: (invoiceIds: string[]) => void | Promise<void>;
  onPaid: (invoiceIds: string[]) => void | Promise<void>;
  onConfirm: (invoiceIds: string[]) => void | Promise<void>;
  currentTab: InvoicesTab;
};

export const TableActionBar = ({
  table,
  onDelete,
  onConfirm,
  onPaid,
  currentTab,
}: Props) => {
  const { t } = useTranslation();

  const rows = table.getSelectedRowModel().rows;

  const rowIds = useMemo(() => {
    return rows.map((row) => row.id);
  }, [rows]);

  if (rows.length === 0) return null;

  return (
    <TableActionBarRoot className="gap-4">
      <TableActionBarRowsSelected table={table} />
      <div className="flex gap-2">
        <TableActionBarButton variant="outline" onClick={handleDelete}>
          <Trash2 className="w-4 h-4" />
          {t("delete")}
        </TableActionBarButton>
        {currentTab === InvoicesTab.TO_REVIEW && (
          <>
            <TableActionBarButton variant="outline" onClick={handlePaid}>
              <X className="w-4 h-4" />
              {t("payables.no_transfer_needed")}
            </TableActionBarButton>
            <TableActionBarButton onClick={handleConfirm}>
              <Check className="w-4 h-4" />
              {t("payments.confirm.label")}
            </TableActionBarButton>
          </>
        )}
      </div>
    </TableActionBarRoot>
  );

  function handleDelete() {
    onDelete(rowIds);
  }

  function handleConfirm() {
    onConfirm(rowIds);
  }

  function handlePaid() {
    onPaid(rowIds);
  }
};
